import { render, staticRenderFns } from "./user-octagon.vue?vue&type=template&id=b1d86cae&"
import script from "./user-octagon.vue?vue&type=script&lang=js&"
export * from "./user-octagon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports